module.exports = __webpack_public_path__ + "static/media/JustActMailers_SME-01.54bfe539.png";